/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {CreateAccountHolderRequest} from '@cash-web/protos/squareup/cash/janus/api/AccountHolder.pb'
import {CreateAccountHolderResponse} from '@cash-web/protos/squareup/cash/janus/api/AccountHolder.pb'


export const createAccountHolderInternal = (request: CreateAccountHolderRequest, options?: CashRequestOptions) => post<CreateAccountHolderRequest, CreateAccountHolderResponse>("/2.0/cash/create-account-holder-internal", request, {...options, rejectOnError: true })